(function () {
  'use strict';

  var CFG = window.__BX || {};
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  function warn(where, error) {
    if (window.console) console.warn('[bundles] ' + where + ' failed:', error);
  }

  /* ---------------------------------------------------------------- gallery */
  try {
    var main = document.querySelector('.bx .stage img');
    var stage = document.querySelector('.bx .stage');
    var thumbs = [].slice.call(document.querySelectorAll('.bx [data-thumb]'));
    if (main && thumbs.length) {
      thumbs.forEach(function (button) {
        button.addEventListener('click', function () {
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = button.getAttribute('data-thumb');
          main.alt = button.getAttribute('data-thumb-alt') || main.alt;
          stage.classList.toggle('is-part', button.classList.contains('thumb--part'));
          thumbs.forEach(function (other) { other.removeAttribute('aria-current'); });
          button.setAttribute('aria-current', 'true');
        });
      });
    }
  } catch (e) { warn('gallery', e); }

  /* -------------------------------------------------------- variant picker */
  try {
    var picker = document.querySelector('.bx [data-variant-select]');
    if (picker) {
      var applyVariant = function () {
        var option = picker.options[picker.selectedIndex];
        if (!option) return;
        var price = option.getAttribute('data-price');
        [].forEach.call(document.querySelectorAll('.bx [data-live-price]'), function (el) {
          el.textContent = price;
        });
        [].forEach.call(document.querySelectorAll('.bx [data-variant-sync]'), function (el) {
          el.value = picker.value;
        });
        if (CFG.product) CFG.product.variant = picker.value;
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', picker.value);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* history is a nicety, never a requirement */ }
      };
      picker.addEventListener('change', applyVariant);
      applyVariant();
    }
  } catch (e) { warn('variant picker', e); }

  /* ----------------------------------------------------------- add to cart */
  function currency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return CFG.currency;
  }

  function track(item) {
    var value = (item.final_line_price != null ? item.final_line_price : item.price) / 100;
    if (typeof gtag === 'function') {
      gtag('event', 'add_to_cart', {
        currency: currency(),
        value: value,
        items: [{
          item_id: item.sku || item.variant_id,
          item_name: item.product_title,
          item_category: 'Bundle',
          price: item.price / 100,
          quantity: item.quantity
        }]
      });
    }
    if (typeof fbq === 'function') {
      fbq('track', 'AddToCart', {
        content_ids: [item.product_id],
        content_type: 'product',
        value: value,
        currency: currency()
      });
    }
  }

  function setError(form, message) {
    var box = form.querySelector('[data-atc-error]');
    if (!box) return;
    box.textContent = message || '';
    box.hidden = !message;
  }

  // The round quick-add on cards has no room for words: it swaps its icon
  // (plus → spinner → check) and says the state through aria-label instead.
  var ICON_BUSY = '<svg class="quick__spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="8" opacity=".2"/><path d="M20 12a8 8 0 0 0-8-8"/></svg>';
  var ICON_DONE = '<svg class="quick__tick" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function addToCart(form, button) {
    var label = button.querySelector('[data-atc-label]') || button;
    var previous = label.innerHTML;
    var iconOnly = button.classList.contains('quick');
    var previousAria = button.getAttribute('aria-label');
    var id = form.querySelector('[name="id"]');
    if (!id || button.disabled) return;

    function show(state, text, icon) {
      if (iconOnly) {
        label.innerHTML = icon;
        button.setAttribute('aria-label', text);
        button.classList.toggle('is-busy', state === 'busy');
        button.classList.toggle('is-done', state === 'done');
      } else {
        label.textContent = text;
      }
    }

    function reset() {
      label.innerHTML = previous;
      label.removeAttribute('data-busy');
      button.disabled = false;
      if (iconOnly) {
        button.classList.remove('is-busy', 'is-done');
        if (previousAria) button.setAttribute('aria-label', previousAria);
      }
    }

    setError(form, '');
    button.disabled = true;
    label.setAttribute('data-busy', '');
    show('busy', CFG.adding || 'Ajout en cours…', ICON_BUSY);

    var body = new FormData();
    body.append('id', id.value);
    body.append('quantity', 1);

    fetch(root + 'cart/add.js', {
      method: 'POST',
      body: body,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || CFG.error);
          return data;
        });
      })
      .then(function (item) {
        track(item);
        return fetch(root + 'cart.js').then(function (response) { return response.json(); });
      })
      .then(function (cart) {
        if (!window.emit) {
          window.location.href = root + 'cart';
          return;
        }
        window.emit('cart:updated', { cart: cart });
        window.emit('quick-cart:updated');
        window.emit('quick-cart:open');
        show('done', CFG.added || 'Ajouté', ICON_DONE);
        setTimeout(reset, 1800);
      })
      .catch(function (error) {
        setError(form, error.message || CFG.error || 'Impossible d’ajouter au panier. Veuillez réessayer.');
        reset();
      });
  }

  function bindForms(scope) {
    [].forEach.call(scope.querySelectorAll('form[action$="/cart/add"]'), function (form) {
      if (form.hasAttribute('data-bound') || !form.querySelector('[data-atc]')) return;
      form.setAttribute('data-bound', '');
      form.addEventListener('submit', function (event) {
        var button = form.querySelector('[data-atc]');
        if (!button) return;
        event.preventDefault();
        addToCart(form, button);
      });
    });
  }

  try {
    [].forEach.call(document.querySelectorAll('.bx'), bindForms);

    var mainForm = document.getElementById('bx-form');
    var stickyButton = document.querySelector('.bx [data-sticky-atc]');
    if (stickyButton && mainForm) {
      stickyButton.addEventListener('click', function () {
        var select = mainForm.querySelector('[data-variant-select]');
        if (select) {
          mainForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
          select.focus({ preventScroll: true });
          return;
        }
        addToCart(mainForm, mainForm.querySelector('[data-atc]'));
      });
    }
  } catch (e) { warn('add to cart', e); }

  /* --------------------------------------------------------- sticky pillcta */
  try {
    var bar = document.querySelector('.bx [data-sticky-bar]');
    var primary = document.getElementById('bx-atc');
    var finalOffer = document.getElementById('bundle-buy');
    if (bar && primary && 'IntersectionObserver' in window) {
      var scrolledPast = false;
      var finalVisible = false;
      var paint = function () {
        var on = scrolledPast && !finalVisible;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        var button = bar.querySelector('[data-sticky-atc]');
        if (button) button.tabIndex = on ? 0 : -1;
      };
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        });
        paint();
      }, { threshold: 0 }).observe(primary);
      if (finalOffer) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { finalVisible = entry.isIntersecting; });
          paint();
        }, { threshold: 0.1 }).observe(finalOffer);
      }
    }
  } catch (e) { warn('sticky bar', e); }

  /* ------------------------------------------------- collection filter/sort */
  try {
    var grid = document.querySelector('.bx [data-grid]');
    if (grid) {
      var cards = [].slice.call(grid.children);
      var chips = [].slice.call(document.querySelectorAll('.bx [data-chip]'));
      var sorter = document.querySelector('.bx [data-sort]');
      var counter = document.querySelector('.bx [data-count]');
      var empty = document.querySelector('.bx [data-empty]');
      var more = document.querySelector('.bx [data-more]');
      var pending = null;
      var goal = 'all';

      var render = function () {
        var ordered = cards.slice();
        var mode = sorter ? sorter.value : 'featured';
        if (mode !== 'featured') {
          ordered.sort(function (a, b) {
            var soldA = a.getAttribute('data-sold') === 'true';
            var soldB = b.getAttribute('data-sold') === 'true';
            if (soldA !== soldB) return soldA ? 1 : -1;
            if (mode === 'price-asc') return a.getAttribute('data-price') - b.getAttribute('data-price');
            if (mode === 'price-desc') return b.getAttribute('data-price') - a.getAttribute('data-price');
            return b.getAttribute('data-save') - a.getAttribute('data-save');
          });
        }
        var shown = 0;
        ordered.forEach(function (card, index) {
          var visible = goal === 'all' || card.getAttribute('data-goal') === goal;
          card.hidden = !visible;
          if (visible) shown++;
          if (grid.children[index] !== card) grid.insertBefore(card, grid.children[index] || null);
        });
        if (counter) counter.textContent = shown;
        if (empty) empty.hidden = shown > 0;
      };

      var loadMore = function () {
        if (!more) return Promise.resolve(true);
        if (pending) return pending;
        var button = more;
        var label = button.textContent;
        button.setAttribute('aria-busy', 'true');
        button.textContent = button.getAttribute('data-loading') || label;
        pending = fetch(button.getAttribute('href'), { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var incoming = doc.querySelector('[data-grid]');
            var next = doc.querySelector('[data-more]');
            var added = [].slice.call(incoming ? incoming.children : []).map(function (card) {
              var node = document.importNode(card, true);
              cards.push(node);
              grid.appendChild(node);
              return node;
            });
            bindForms(grid);
            render();
            if (next) {
              button.setAttribute('href', next.getAttribute('href'));
              button.textContent = label;
              button.removeAttribute('aria-busy');
            } else {
              var focused = document.activeElement === button;
              var shell = button.parentNode;
              if (shell && shell.parentNode) shell.parentNode.removeChild(shell);
              more = null;
              var first = added[0] && added[0].querySelector('a');
              if (focused && first) first.focus({ preventScroll: true });
            }
            return true;
          })
          .catch(function (error) {
            warn('load more', error);
            button.textContent = label;
            button.removeAttribute('aria-busy');
            return false;
          })
          .then(function (ok) {
            pending = null;
            return ok;
          });
        return pending;
      };

      var loadAll = function () {
        return loadMore().then(function (ok) { return ok !== false && more ? loadAll() : null; });
      };

      var refresh = function () {
        var narrowed = goal !== 'all' || (sorter && sorter.value !== 'featured');
        if (narrowed && more) loadAll().then(render);
        else render();
      };

      if (more) {
        more.addEventListener('click', function (event) {
          if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          var href = more.href;
          loadMore().then(function (ok) { if (ok === false) window.location.href = href; });
        });
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (other) { other.setAttribute('aria-pressed', 'false'); });
          chip.setAttribute('aria-pressed', 'true');
          goal = chip.getAttribute('data-chip');
          refresh();
        });
      });
      if (sorter) sorter.addEventListener('change', refresh);
    }
  } catch (e) { warn('collection tools', e); }

  /* ------------------------------------------------------------ view events */
  try {
    if (CFG.view === true && !window.__BX_VIEWED) {
      window.__BX_VIEWED = true;
      var p = CFG.product || {};
      var price = (p.price || 0) / 100;
      if (typeof gtag === 'function') {
        gtag('event', 'view_item', {
          currency: currency(),
          value: price,
          items: [{ item_id: p.sku || p.variant, item_name: p.title, item_brand: p.vendor, item_category: 'Bundle', price: price, quantity: 1 }]
        });
      }
      if (typeof fbq === 'function') {
        fbq('track', 'ViewContent', {
          content_ids: [String(p.id)], content_name: p.title, content_type: 'product', value: price, currency: currency()
        });
      }
    }
  } catch (e) { warn('view event', e); }
})();
